(() => {
  document.documentElement.classList.add('js');
  const STORE = '';
  const FF = window.FF_FILES || './assets/';
  const FREE_SHIP = 75;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = n => '$' + n.toFixed(2);

  /* ---------- Catalog (live Shopify variant IDs) ---------- */
  const P = [
    { key:'blessed', photo:'shop-blessed.webp', handle:'blessed-berry-pre-workout', name:'Blessed Berry Pre-Workout', short:'Blessed Berry', kicker:'Pre-workout', desc:'250mg caffeine, 5,000mg citrulline malate and 2,000mg beta-alanine for strong energy and pumps.', price:47.99, compare:49.99, vid:51835429421330, cat:'pre', need:true, badge:'Save $2', feature:true, img:'p-blessed-berry-pre-workout.webp', w:598, h:626 },
    { key:'crusader', photo:'shop-crusader.webp', handle:'crusader-creamsicle-pre-workout', name:'Crusader Creamsicle Pre-Workout', short:'Crusader Creamsicle', kicker:'Pre-workout', desc:'Stronger energy, bigger pumps, focused intensity.', price:47.99, compare:49.99, vid:52168429764882, cat:'pre', badge:'Best seller', img:'p-crusader-creamsicle-pre-workout.webp', w:702, h:730 },
    { key:'profuel', handle:'pro-fuel-premium-whey-protein-powder', name:'Pro-Fuel Whey \u00b7 Vanilla Ice Cream', short:'Pro-Fuel \u00b7 Vanilla Ice Cream', kicker:'Whey protein', desc:'25g protein per scoop with digestive enzymes. Smooth, classic vanilla.', price:59.99, vid:50300248490258, cat:'post', img:'pf-van.webp', w:616, h:800 },
    { key:'profuel-cin', photo:'shop-profuel-cin.webp', handle:'pro-fuel-premium-whey-protein-powder', name:'Pro-Fuel Whey \u00b7 Cinnamon Swirl', short:'Pro-Fuel \u00b7 Cinnamon Swirl', kicker:'Whey protein', desc:'25g protein per scoop. Tastes like a fresh-baked cinnamon roll.', price:59.99, vid:45815980556562, cat:'post', need:true, badge:'Best seller', img:'pf-cin.webp', w:589, h:800 },
    { key:'crown', photo:'shop-crown.webp', sizes:[['crown','100 servings'],['crown60','60 servings']], handle:'crown-of-thorns-creatine-monohydrate', name:'Crown of Thorns Creatine', short:'Crown of Thorns \u00b7 100 servings', kicker:'Creatine', desc:'100% pure creatine monohydrate. Non-GMO, third-party tested.', price:44.99, vid:50300273819922, cat:'post', need:true, img:'p-crown-of-thorns-creatine-monohydrate.webp', w:764, h:800 },
    { key:'crown60', photo:'shop-crown.webp', handle:'crown-of-thorns-creatine-monohydrate', name:'Crown of Thorns \u00b7 60 servings', short:'Crown of Thorns \u00b7 60 servings', kicker:'Creatine', price:33.99, vid:52092059025682, stackOnly:true, img:'p-crown-of-thorns-creatine-monohydrate.webp' },
    { key:'lauds', photo:'shop-lauds.webp', handle:'lauds-lemon-electrolytes', name:'Lauds Lemon Electrolytes', short:'Lauds Lemon', kicker:'Electrolytes', desc:'Sugar-free with 500mg sodium and 1,000mg real lemon powder. No artificial sweeteners.', price:39.99, vid:52237758824722, cat:'during', need:true, badge:'New', img:'p-lauds-lemon-electrolytes.webp', w:800, h:698 },
    { key:'solomon', photo:'shop-solomon.webp', handle:'solomon-strawberry-electrolytes', name:'Solomon Strawberry Electrolytes', short:'Solomon Strawberry', kicker:'Electrolytes', desc:'Sugar-free with 500mg sodium and 1,000mg real strawberry powder. No artificial sweeteners.', price:39.99, vid:52237558481170, cat:'during', badge:'New', img:'p-solomon-strawberry-electrolytes.webp', w:800, h:698 },
  ];
  const byKey = Object.fromEntries(P.map(p => [p.key, p]));
  // Shopify subscribe-and-save plans (monthly 10% for most; creatine every 100 days 10%)
  const SUB_MONTHLY = 694904914194, SUB_CREATINE = 694973530386;
  const subOf = p => ({ plan: p.cat === 'post' && p.key.startsWith('crown') ? SUB_CREATINE : SUB_MONTHLY, price: Math.round(p.price * 90) / 100 });
  const pdp = p => `${STORE}/products/${p.handle}`;
  const cartUrl = (items, code) => `${STORE}/cart/${items.map(p => p.vid + ':1').join(',')}${code ? '?discount=' + encodeURIComponent(code) : ''}`;

  /* ---------- Product grid ---------- */
  const grid = $('#grid');
  grid.innerHTML = P.filter(p => !p.stackOnly).map(p => {
    const badge = p.badge ? `<span class="badge ${/Save/.test(p.badge)?'badge--gold':''}">${p.badge}</span>` : '';
    return `<article class="card ${p.feature?'card--feature':''} reveal" data-cat="${p.cat}" data-need="${p.need?1:0}">
      <a class="card__stretch" href="${pdp(p)}" aria-label="View ${p.name}"></a>
      <div class="card__media${p.photo ? ' card__media--photo' : ''}">${badge}<img src="${FF}${p.photo || p.img}" alt="${p.name}" width="${p.photo ? 880 : p.w}" height="${p.photo ? 1100 : p.h}" loading="lazy" decoding="async"/></div>
      <div class="card__body">
        <p class="card__kicker">${p.kicker}</p>
        <h3 class="card__title">${p.name}</h3>
        <p class="card__desc">${p.desc}</p>
        ${p.sizes ? `<div class="card__sizes" role="radiogroup" aria-label="Size">${p.sizes.map(([k, t], i) => `<button type="button" class="card__size${i ? '' : ' is-on'}" role="radio" aria-checked="${!i}" data-size="${k}">${t}</button>`).join('')}</div>` : ''}
        <div class="card__row">
          <p class="card__price">${money(p.price)}${p.compare?`<s>${money(p.compare)}</s>`:''}</p>
          <a class="card__add" href="${cartUrl([p])}" aria-label="Add ${p.name} to cart">Add to cart</a>
        </div>
        <a class="card__sub" href="${pdp(p)}?variant=${p.vid}&selling_plan=${subOf(p).plan}" aria-label="Subscribe to ${p.name} and save 10%"><span class="card__sub-dot" aria-hidden="true"></span>Subscribe &amp; save 10% \u00b7 ${money(subOf(p).price)}</a>
      </div>
    </article>`;
  }).join('') + `<a class="card card--all" href="${STORE}/collections/all" data-cat="all"><span class="card--all__k">Shop all</span><span class="card--all__t">See every Flight Foods product</span><span class="card--all__arrow" aria-hidden="true">\u2192</span></a>`;

  /* size selector on cards (Crown of Thorns 100 / 60 servings) */
  $$('.card__sizes').forEach(g => g.addEventListener('click', e => {
    const b = e.target.closest('.card__size'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const p = byKey[b.dataset.size], c = g.closest('.card');
    $$('.card__size', g).forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
    $('.card__price', c).innerHTML = money(p.price) + (p.compare ? `<s>${money(p.compare)}</s>` : '');
    const add = $('.card__add', c); add.href = cartUrl([p]); add.setAttribute('aria-label', `Add ${p.name} to cart`);
    const sub = $('.card__sub', c); sub.href = `${pdp(p)}?variant=${p.vid}&selling_plan=${subOf(p).plan}`;
    sub.innerHTML = `<span class="card__sub-dot" aria-hidden="true"></span>Subscribe &amp; save 10% \u00b7 ${money(subOf(p).price)}`;
    $('.card__stretch', c).href = `${pdp(p)}?variant=${p.vid}`;
  }));

  if (!reduce && matchMedia('(hover:hover)').matches) {
    $$('.card:not(.card--all)').forEach(c => {
      const img = $('.card__media img', c);
      c.addEventListener('pointermove', e => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        img.style.transform = `scale(1.06) rotateY(${x * 10}deg) rotateX(${-y * 8}deg)`;
      });
      c.addEventListener('pointerleave', () => { img.style.transform = ''; });
    });
  }
  const applyFilter = f => {
    grid.dataset.view = f;
    $$('.card').forEach(c => c.classList.toggle('is-hidden',
      f === 'all' ? false : f === 'need' ? c.dataset.need !== '1' : c.dataset.cat !== f));
  };
  applyFilter('need');
  $$('.tab').forEach(t => t.addEventListener('click', () => {
    $$('.tab').forEach(x => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
    const f = t.dataset.filter;
    applyFilter(f);
    $$('.card:not(.is-hidden)').forEach((c, i) => c.animate?.([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 450, delay: i * 40, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' }));
  }));

  /* ---------- Hero picker + variant selector ---------- */
  const PRE_TAGS = [['250','mg','Caffeine'],['5,000','mg','Citrulline malate'],['2,000','mg','Beta-alanine']];
  const PF_TAGS = [['25','g','Protein per scoop'],['Digestive enzymes','','Easy on the stomach'],['Complete','','Amino acid profile \u00b7 BCAAs included']];
  const CR_TAGS = [['100','%','Pure creatine monohydrate'],['Non-GMO','','Clean ingredients'],['3rd party','','Tested']];
  const VD = {
    blessed:     { name:'Blessed Berry Pre-Workout', img:'hero-blessed-scoop.webp', photo:true, cap:['Blessed Berry','Enhanced pre-workout'], tags:PRE_TAGS },
    crusader:    { name:'Crusader Creamsicle Pre-Workout', img:'hero-crusader-scoop.webp', photo:true, cap:['Crusader Creamsicle','Enhanced pre-workout'], tags:PRE_TAGS },
    lauds:       { name:'Lauds Lemon Electrolytes', img:'hero-lauds-scoop.webp', photo:true, cap:['Lauds Lemon','Electrolytes'], tags:[['1,000','mg','Real lemon powder'],['0','g','Sugar'],['0','','Artificial dyes or sweeteners']] },
    solomon:     { name:'Solomon Strawberry Electrolytes', img:'hero-solomon-scoop.webp', photo:true, cap:['Solomon Strawberry','Electrolytes'], tags:[['1,000','mg','Real strawberry powder'],['0','g','Sugar'],['0','','Artificial dyes or sweeteners']] },
    profuel:     { name:'Pro-Fuel Whey Protein', img:'pf-van.webp', cap:['Pro-Fuel','Vanilla Ice Cream'], tags:PF_TAGS },
    'profuel-cin':{ name:'Pro-Fuel Whey Protein', img:'hero-profuel-cin-scoop.webp', photo:true, cap:['Pro-Fuel','Cinnamon Swirl'], tags:PF_TAGS },
    crown:       { name:'Crown of Thorns Creatine', img:'hero-crown-scoop.webp', photo:true, cap:['Crown of Thorns','Creatine \u00b7 100 servings'], tags:CR_TAGS },
    crown60:     { name:'Crown of Thorns Creatine', img:'hero-crown-scoop.webp', photo:true, cap:['Crown of Thorns','Creatine \u00b7 60 servings'], tags:CR_TAGS },
  };
  const GROUPS = {
    blessed: { label:'Type', opts:[['blessed','Blessed Berry'],['crusader','Crusader Creamsicle']] },
    lauds:   { label:'Flavor', opts:[['lauds','Lauds Lemon'],['solomon','Solomon Strawberry']] },
    profuel: { label:'Flavor', opts:[['profuel','Vanilla Ice Cream'],['profuel-cin','Cinnamon Swirl']] },
    crown:   { label:'Size', opts:[['crown60','60 servings'],['crown','100 servings']] },
  };
  const chosen = { blessed:'blessed', lauds:'lauds', profuel:'profuel-cin', crown:'crown' };
  let group = 'blessed';
  Object.values(VD).forEach(v => { const im = new Image(); im.src = FF + v.img; });
  function renderTags(tags, animate) {
    const ul = $('#stageTags');
    ul.innerHTML = tags.map(([v, u, l], i) => `<li class="stage__tag" style="--i:${i}"><span class="stage__tag-v${v.length > 5 ? ' stage__tag-v--word' : ''}">${v}<small>${u}</small></span><span class="stage__tag-l">${l}</span></li>`).join('');
    if (animate && !reduce) $$('.stage__tag', ul).forEach((el, i) => el.animate([{ opacity: 0, transform: 'translateX(16px)' }, { opacity: 1, transform: 'none' }], { duration: 600, delay: 250 + i * 90, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' }));
  }
  function renderVarOpts() {
    const g = GROUPS[group];
    $('#bbVar').innerHTML = g.opts.map(([k, t]) => `<button type="button" class="vsel__opt${chosen[group] === k ? ' is-active' : ''}" role="radio" aria-checked="${chosen[group] === k}" data-v="${k}">${t}</button>`).join('');
  }
  function applyVariant(k, animateTags, swapImg) {
    const p = byKey[k], v = VD[k];
    $('#bbName').textContent = v.name;
    $('#bbCartPrice').textContent = money(p.price);
    $('#bbCart').href = cartUrl([p]);
    const fig = $(`.pol[data-key="${group}"]`), img = $('.pol__photo img', fig);
    const setImg = () => { img.src = FF + v.img; img.alt = v.name; fig.classList.toggle('pol--photo', !!v.photo); fig.dataset.v = k; $('.pol__name', fig).textContent = v.cap[0]; $('.pol__meta', fig).textContent = v.cap[1]; };
    if (swapImg && !img.src.endsWith(v.img) && !reduce) {
      img.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180, fill: 'forwards' }).finished.then(() => {
        setImg(); img.getAnimations().forEach(a => a.cancel());
        img.animate([{ opacity: 0, transform: 'scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
      });
    } else setImg();
    renderTags(v.tags, animateTags);
    $('#stName').textContent = v.cap[0]; $('#stPrice').textContent = money(p.price); $('#stCart').href = cartUrl([p]);
  }
  function setHero(key) {
    group = key;
    $$('.pol').forEach(el => {
      const on = el.dataset.key === key;
      if (el.classList.contains('is-on') && !on) { el.classList.add('is-out'); setTimeout(() => el.classList.remove('is-out'), 700); }
      el.classList.toggle('is-on', on); el.setAttribute('aria-hidden', !on);
    });
    renderVarOpts();
    applyVariant(chosen[key], true, false);
    window.dispatchEvent(new CustomEvent('ff:flavor', { detail: key }));
  }
  $('#bbVar').addEventListener('click', e => {
    const b = e.target.closest('.vsel__opt'); if (!b || b.classList.contains('is-active')) return;
    chosen[group] = b.dataset.v; renderVarOpts(); applyVariant(b.dataset.v, true, true);
  });
  renderVarOpts(); applyVariant('blessed', false, false);
  $$('.picker__opt').forEach(b => b.addEventListener('click', () => {
    if (b.classList.contains('is-active')) return;
    $$('.picker__opt').forEach(x => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-checked', x === b); });
    setHero(b.dataset.key);
  }));
  $('.picker').addEventListener('keydown', e => {
    if (!['ArrowRight','ArrowLeft'].includes(e.key)) return;
    const opts = $$('.picker__opt'), i = opts.findIndex(o => o.classList.contains('is-active'));
    const n = opts[(i + (e.key === 'ArrowRight' ? 1 : opts.length - 1)) % opts.length];
    n.focus(); n.click();
  });

  /* ---------- Pre-built stacks ---------- */
  // Discount codes must exist in Shopify (Discounts) for the savings to apply at checkout.
  const BUNDLES = [
    { id:'foundation', tag:'Start here', title:'Foundation Stack', sub:'Daily strength + real hydration. The two things every athlete should take.',
      items:['crown','lauds'], swap:{ label:'Electrolyte', opts:['lauds','solomon'] }, photos:{ lauds:'foundation-lauds.webp', solomon:'foundation-solomon.webp' },
      upgrade:{ add:'profuel', opts:['profuel','profuel-cin'], optLabel:'Pro-Fuel flavor', pct:15, code:'FOUNDATION15', label:'Add Pro-Fuel whey and save 15% on the whole stack' } },
  ];
  const bState = { foundation:{ swap:'lauds', up:false, upPick:'profuel' } };
  const flav = k => byKey[k].short.split(' \u00b7 ')[1] || byKey[k].short;
  const upKey = (b, st) => (b.upgrade.opts && st.upPick) || b.upgrade.add;
  function bundleCalc(b) {
    const st = bState[b.id];
    let keys = b.items.slice();
    if (b.swap) keys = keys.map(k => b.swap.opts.includes(k) ? st.swap : k);
    let pct = b.pct || 0, code = b.code || null;
    if (b.upgrade && st.up) { keys.push(upKey(b, st)); pct = b.upgrade.pct; code = b.upgrade.code; }
    const items = keys.map(k => byKey[k]);
    const full = items.reduce((a, p) => a + p.price, 0);
    const total = full * (1 - pct / 100);
    return { items, full, total, pct, code };
  }
  function bundleHTML(b) {
    const c = bundleCalc(b), st = bState[b.id];
    const photo = b.photos && b.photos[st.swap];
    const imgs = photo
      ? `<img class="bundle__photo" src="${FF}${photo}" alt="${c.items.filter(p => p.key !== (b.upgrade && st.up ? upKey(b, st) : '')).map(p => p.short.split(' \u00b7 ')[0]).join(' and ')}" width="960" height="1200" loading="lazy" />` +
        (b.upgrade && st.up ? `<span class="bundle__plus"><img src="${FF}${byKey[upKey(b, st)].img}" alt="" loading="lazy" />+ ${byKey[upKey(b, st)].short.split(' \u00b7 ')[0]}</span>` : '')
      : c.items.map((p, i) => `<img src="${FF}${p.img}" alt="" style="--i:${i};--n:${c.items.length}" loading="lazy" />`).join('');
    return `<article class="bundle ${b.id === 'full' ? 'bundle--dark' : ''} reveal" data-id="${b.id}">
      <div class="bundle__media${photo ? ' bundle__media--photo' : ''}">${imgs}</div>
      <div class="bundle__body">
        <p class="bundle__tag">${b.tag}</p>
        <h3 class="bundle__title">${b.title}</h3>
        <p class="bundle__sub">${b.sub}</p>
        <ul class="bundle__items">${c.items.map(p => `<li><span>${p.short}</span><span>${money(p.price)}</span></li>`).join('')}</ul>
        ${b.swap ? `<div class="bundle__swap" role="group" aria-label="${b.swap.label}">${b.swap.opts.map(k => `<button class="chip ${st.swap===k?'is-on':''}" data-swap="${k}" aria-pressed="${st.swap===k}">${byKey[k].short}</button>`).join('')}</div>` : ''}
        ${b.upgrade ? `<label class="upgrade ${st.up?'is-on':''}"><input type="checkbox" ${st.up?'checked':''} data-up /><span class="upgrade__sw" aria-hidden="true"></span><span class="upgrade__t">${b.upgrade.label}</span><span class="upgrade__p">+${money(byKey[upKey(b, st)].price)}</span></label>` : ''}
        ${b.upgrade && b.upgrade.opts && st.up ? `<div class="bundle__swap bundle__swap--up" role="group" aria-label="${b.upgrade.optLabel}"><span class="bundle__swapl">${b.upgrade.optLabel}</span>${b.upgrade.opts.map(k => `<button class="chip ${st.upPick===k?'is-on':''}" data-uppick="${k}" aria-pressed="${st.upPick===k}">${flav(k)}</button>`).join('')}</div>` : ''}
        <div class="bundle__foot">
          <div class="bundle__price"><strong>${money(c.total)}</strong>${c.pct ? `<s>${money(c.full)}</s><span class="save">Save ${c.pct}%</span>` : '<span class="save save--muted">Free shipping unlocked</span>'}</div>
          <a class="btn ${b.id==='full'?'btn--gold':'btn--ink'} btn--lg" href="${cartUrl(c.items, c.code)}">Add stack to cart</a>
        </div>
      </div>
    </article>`;
  }
  function renderBundles() { $('#bundles').innerHTML = BUNDLES.map(bundleHTML).join(''); $$('#bundles .reveal').forEach(el => el.style.opacity = 1); }
  renderBundles();
  $('#bundles').addEventListener('click', e => {
    const card = e.target.closest('.bundle'); if (!card) return;
    const sw = e.target.closest('[data-swap]');
    if (sw) { bState[card.dataset.id].swap = sw.dataset.swap; renderBundles(); }
    const up = e.target.closest('[data-uppick]');
    if (up) { bState[card.dataset.id].upPick = up.dataset.uppick; renderBundles(); $(`.bundle[data-id="${card.dataset.id}"] [data-uppick="${up.dataset.uppick}"]`)?.focus(); }
  });
  $('#bundles').addEventListener('change', e => {
    if (!e.target.matches('[data-up]')) return;
    const id = e.target.closest('.bundle').dataset.id; bState[id].up = e.target.checked; renderBundles();
    $(`.bundle[data-id="${id}"] [data-up]`)?.focus();
  });

  /* ---------- Founder's stack ---------- */
  const FOUNDER = { base:['crusader','crown','profuel'], pct:10, code:'FOUNDER10', up:{ add:'solomon', opts:['solomon','lauds'], pct:15, code:'FOUNDER15' } };
  let fUp = false, fPick = 'solomon';
  function renderFounder() {
    const keys = FOUNDER.base.concat(fUp ? [fPick] : []);
    const items = keys.map(k => byKey[k]);
    const full = items.reduce((a, p) => a + p.price, 0);
    const pct = fUp ? FOUNDER.up.pct : FOUNDER.pct, code = fUp ? FOUNDER.up.code : FOUNDER.code;
    $('#fstack').innerHTML = `<p class="fstack__label">The Founder\u2019s Stack</p>
      <ul class="fstack__items">${items.map(p => `<li><img src="${FF}${p.img}" alt="" loading="lazy"/><span><b>${p.short.split(' \u00b7 ')[0]}</b><small>${p.kicker}</small></span></li>`).join('')}</ul>
      <p class="fstack__note">The exact stack behind the transformation: creatine, Pro-Fuel and the pre-workout that became Crusader Creamsicle.</p>
      <label class="upgrade ${fUp?'is-on':''}"><input type="checkbox" id="fUp" ${fUp?'checked':''}/><span class="upgrade__sw" aria-hidden="true"></span><span class="upgrade__t">Upgrade with electrolytes and save 15%</span><span class="upgrade__p">+${money(byKey[fPick].price)}</span></label>
      ${fUp ? `<div class="bundle__swap bundle__swap--up" role="group" aria-label="Electrolyte flavor"><span class="bundle__swapl">Electrolyte flavor</span>${FOUNDER.up.opts.map(k => `<button type="button" class="chip ${fPick===k?'is-on':''}" data-fpick="${k}" aria-pressed="${fPick===k}">${byKey[k].short}</button>`).join('')}</div>` : ''}
      <div class="bundle__foot">
        <div class="bundle__price"><strong>${money(full * (1 - pct / 100))}</strong><s>${money(full)}</s><span class="save">Save ${pct}%</span></div>
        <a class="btn btn--gold btn--lg" href="${cartUrl(items, code)}">Get the Founder\u2019s Stack</a>
      </div>`;
    $('#fUp').addEventListener('change', e => { fUp = e.target.checked; renderFounder(); $('#fUp').focus(); });
    $$('#fstack [data-fpick]').forEach(b => b.addEventListener('click', () => { fPick = b.dataset.fpick; renderFounder(); $(`#fstack [data-fpick="${fPick}"]`)?.focus(); }));
  }
  renderFounder();

  /* ---------- Before / after slider ---------- */
  const ba = $('#ba'), baRange = $('#baRange');
  const setBA = v => ba.style.setProperty('--pos', v + '%');
  baRange.addEventListener('input', e => setBA(e.target.value));

  /* ---------- App carousel: 5 screens, 3 visible ---------- */
  (function phones() {
    const box = $('#phones'); if (!box) return;
    const imgs = $$('.phone', box), n = imgs.length, dots = $('#phoneDots');
    let cur = 0, timer;
    dots.innerHTML = imgs.map((_, i) => `<button type="button" aria-label="Show app screen ${i + 1}"></button>`).join('');
    const db = $$('button', dots);
    function place() {
      imgs.forEach((im, i) => {
        let d = (i - cur + n) % n; if (d > n / 2) d -= n;
        im.dataset.pos = Math.abs(d) <= 1 ? d : (d > 0 ? 'r' : 'l');
        im.setAttribute('aria-hidden', d !== 0);
      });
      db.forEach((b, i) => b.setAttribute('aria-current', i === cur));
    }
    const go = i => { cur = (i + n) % n; place(); };
    const play = () => { if (reduce) return; clearInterval(timer); timer = setInterval(() => go(cur + 1), 3000); };
    imgs.forEach((im, i) => im.addEventListener('click', () => { go(i); play(); }));
    db.forEach((b, i) => b.addEventListener('click', () => { go(i); play(); }));
    box.addEventListener('pointerenter', () => clearInterval(timer));
    box.addEventListener('pointerleave', play);
    new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? play() : clearInterval(timer))).observe(box);
    place();
  })();

  /* ---------- Electrolyte cards: ingredients on hover / tap ---------- */
  $$('.duo__flip').forEach(b => b.addEventListener('click', () => {
    const c = b.closest('.duo__card'), on = !c.classList.contains('is-ing');
    c.classList.toggle('is-ing', on); b.setAttribute('aria-pressed', on);
  }));

  /* ---------- Nav dropdowns + mobile menu ---------- */
  (function navMenu() {
    const nav = $('#nav'), dds = $$('.dd', nav), burger = $('#burger');
    const hover = matchMedia('(hover:hover) and (min-width:961px)');
    const close = (except) => dds.forEach(d => { if (d !== except) { d.classList.remove('is-open'); $('.dd__btn', d).setAttribute('aria-expanded', 'false'); } });
    dds.forEach(d => {
      const btn = $('.dd__btn', d); let t;
      const open = () => { close(d); d.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      btn.addEventListener('click', () => d.classList.contains('is-open') ? close() : open());
      d.addEventListener('pointerenter', () => { if (hover.matches) { clearTimeout(t); open(); } });
      d.addEventListener('pointerleave', () => { if (hover.matches) t = setTimeout(() => close(), 160); });
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); btn.focus(); } });
    });
    document.addEventListener('click', e => { if (!nav.contains(e.target)) close(); });
    const setMenu = (on) => { nav.classList.toggle('menu-open', on); burger.setAttribute('aria-expanded', on); burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu'); document.body.style.overflow = on ? 'hidden' : ''; };
    burger.addEventListener('click', () => setMenu(!nav.classList.contains('menu-open')));
    $$('.menu a', nav).forEach(a => a.addEventListener('click', () => { setMenu(false); close(); }));
  })();

  /* ---------- Reviews: auto-fading carousel ---------- */
  (function reviews() {
    const stage = $('#rail'); if (!stage) return;
    const all = $$('.review', stage), n = all.length, dots = $('#revDots');
    const per = () => innerWidth <= 760 ? 1 : innerWidth <= 1100 ? 2 : 3;
    let start = 0, timer, k = per();
    const pages = () => Math.ceil(n / per());
    function show(animate) {
      k = per();
      const vis = Array.from({ length: k }, (_, i) => (start + i) % n);
      all.forEach((r, i) => {
        const on = vis.includes(i);
        r.classList.toggle('is-on', on); r.style.order = on ? vis.indexOf(i) : 99;
        if (on && animate && !reduce) r.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 700, delay: vis.indexOf(i) * 110, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' });
      });
      const pg = Math.floor(start / k) % pages();
      dots.innerHTML = Array.from({ length: pages() }, (_, i) => `<button type="button" aria-label="Show reviews ${i + 1} of ${pages()}" aria-current="${i === pg}"></button>`).join('');
    }
    function go(s) {
      if (reduce) { start = s; show(false); return; }
      const out = $$('.review.is-on', stage);
      Promise.all(out.map(r => r.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 350, easing: 'ease-out', fill: 'forwards' }).finished)).then(() => {
        out.forEach(r => r.getAnimations().forEach(an => an.cancel()));
        start = ((s % n) + n) % n; show(true);
      });
    }
    const play = () => { if (reduce) return; clearInterval(timer); timer = setInterval(() => go(start + per()), 5500); };
    dots.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; go([...dots.children].indexOf(b) * per()); play(); });
    stage.addEventListener('pointerenter', () => clearInterval(timer));
    stage.addEventListener('pointerleave', play);
    stage.addEventListener('focusin', () => clearInterval(timer));
    addEventListener('resize', () => { if (per() !== k) { start = 0; show(false); } });
    new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? play() : clearInterval(timer))).observe(stage);
    show(false);
  })();

  /* ---------- Stack builder ---------- */
  const STEPS = [
    { t:'Before', s:'Pre-workout \u00b7 energy & pumps', opts:['blessed','crusader'] },
    { t:'During', s:'Electrolytes \u00b7 hydration', opts:['lauds','solomon'] },
    { t:'After', s:'Whey protein \u00b7 recovery', opts:['profuel','profuel-cin'] },
    { t:'Daily', s:'Creatine \u00b7 strength', opts:['crown','crown60'] },
  ];
  const sel = { 0:'blessed', 1:'lauds', 2:null, 3:'crown' };
  const romans = ['I','II','III','IV'];
  const check = '<span class="opt__chk"><svg viewBox="0 0 24 24"><path d="m5 12 5 5 9-10"/></svg></span>';
  const optName = p => p.short.replace('Pro-Fuel \u00b7 ','').replace('Crown of Thorns \u00b7 ','Crown of Thorns \u00b7 ');
  $('#steps').innerHTML = STEPS.map((st, i) => `<li class="step reveal">
    <div class="step__head"><span class="step__n">${romans[i]}.</span><span class="step__t">${st.t}</span><span class="step__s">${st.s}</span></div>
    <div class="opts">${st.opts.map(k => { const p = byKey[k]; return `<button class="opt" data-step="${i}" data-key="${k}" aria-pressed="false"><img src="${FF}${p.img}" alt="" width="52" height="52" loading="lazy"/><span><span class="opt__t">${optName(p)}</span><br/><span class="opt__p">${money(p.price)}</span></span>${check}</button>`; }).join('')}</div>
  </li>`).join('');
  function renderStack() {
    $$('.opt').forEach(o => o.setAttribute('aria-pressed', sel[o.dataset.step] === o.dataset.key));
    const items = Object.values(sel).filter(Boolean).map(k => byKey[k]);
    const total = items.reduce((a, p) => a + p.price, 0);
    $('#sumItems').innerHTML = items.length ? items.map(p => `<li><span>${p.short}</span><span>${money(p.price)}</span></li>`).join('') : '<li class="summary__empty">Pick at least one product.</li>';
    $('#sumTotal').textContent = money(total);
    $('#shipFill').style.width = Math.min(100, total / FREE_SHIP * 100) + '%';
    $('#shipMsg').innerHTML = total >= FREE_SHIP ? '<strong>You\u2019ve unlocked free shipping.</strong>' : `Add <strong>${money(FREE_SHIP - total)}</strong> for free shipping`;
    const co = $('#sumCheckout');
    if (items.length) { co.href = cartUrl(items); co.removeAttribute('aria-disabled'); co.textContent = `Checkout ${items.length}-item stack`; }
    else { co.setAttribute('aria-disabled', 'true'); co.textContent = 'Checkout stack'; }
  }
  $('#steps').addEventListener('click', e => {
    const o = e.target.closest('.opt'); if (!o) return;
    const s = o.dataset.step; sel[s] = sel[s] === o.dataset.key ? null : o.dataset.key;
    renderStack();
  });
  renderStack();

  /* ---------- Flight path progress ---------- */
  const secs = $$('[data-cp]');
  const cpsEl = $('#flightCps'), plane = $('#flightPlane'), trail = $('#flightTrail');
  cpsEl.innerHTML = secs.map((s, i) => `<li class="cp" data-i="${i}"><a href="#${s.id}" aria-label="${s.dataset.cp}"><span class="cp__dot"></span><span class="cp__label">${s.dataset.cp}</span></a></li>`).join('');
  const cps = $$('.cp', cpsEl);
  let cpPos = [], lastActive = -1, flashT;
  function layoutCps() {
    const max = document.documentElement.scrollHeight - innerHeight;
    cpPos = secs.map((s, i) => i === 0 ? 0 : i === secs.length - 1 ? 1 : Math.min(1, Math.max(0, (s.getBoundingClientRect().top + scrollY - innerHeight * .35) / max)));
    cps.forEach((c, i) => c.style.top = (cpPos[i] * 100) + '%');
  }
  function updateFlight() {
    const max = document.documentElement.scrollHeight - innerHeight;
    const p = max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0;
    plane.style.top = (p * 100) + '%';
    trail.style.height = (p * 100) + '%';
    let active = 0; cpPos.forEach((v, i) => { if (p + .002 >= v) active = i; });
    cps.forEach((c, i) => { c.classList.toggle('is-passed', i < active); c.classList.toggle('is-active', i === active); });
    if (active !== lastActive) {
      lastActive = active; const c = cps[active]; c.classList.add('is-flash');
      clearTimeout(flashT); flashT = setTimeout(() => c.classList.remove('is-flash'), 1400);
      cps.forEach((x, i) => i !== active && x.classList.remove('is-flash'));
    }
    $('#flight').classList.toggle('is-landed', p > .995);
  }
  layoutCps(); updateFlight();
  addEventListener('resize', () => { layoutCps(); updateFlight(); });
  addEventListener('load', () => { layoutCps(); updateFlight(); });
  new ResizeObserver(() => { layoutCps(); updateFlight(); }).observe(document.body);

  /* ---------- Nav + sticky CTA ---------- */
  const nav = $('#nav'), sticky = $('#sticky'), hero = $('.hero');
  let lastY = 0;
  addEventListener('scroll', () => {
    const y = scrollY;
    nav.classList.toggle('is-scrolled', y > 10);
    nav.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !nav.classList.contains('menu-open') && !nav.querySelector('.dd.is-open'));
    if (y < lastY - 4) nav.classList.remove('is-hidden');
    lastY = y;
    const on = y > hero.offsetHeight * .8;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', !on);
    $('#stCart').tabIndex = on ? 0 : -1;
    updateFlight();
  }, { passive: true });

  /* ---------- Signup ---------- */
  $('#signup')?.addEventListener('submit', e => {
    const inp = $('#email'), msg = $('#signupMsg');
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim());
    if (!ok) { e.preventDefault(); msg.classList.add('is-err'); msg.textContent = 'Please enter a valid email address.'; }
  });

  $('#footSignup')?.addEventListener('submit', e => {
    const inp = $('#footEmail'), msg = $('#footMsg');
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim());
    if (!ok) { e.preventDefault(); msg.classList.add('is-err'); msg.textContent = 'Please enter a valid email address.'; }
  });

  /* ---------- GSAP motion ---------- */
  (function initMotion() {
    const g = window.gsap;
    if (!g || reduce) { $$('.reveal').forEach(el => el.style.opacity = 1); return; }
    g.registerPlugin(window.ScrollTrigger);
    g.from('.hero__title .line > span', { yPercent: 110, duration: 1.1, ease: 'power4.out', stagger: .08, delay: .1 });
    g.from(['.hero .eyebrow', '.hero__lede', '.picker__label', '.picker', '.buybox', '.hero__ctas', '.hero__trust'], { opacity: 0, y: 16, duration: .9, ease: 'power3.out', stagger: .06, delay: .45 });
    g.from('.stage__tag', { opacity: 0, x: 24, duration: 1, ease: 'power3.out', stagger: .1, delay: .9 });
    g.from('.flight', { opacity: 0, x: -20, duration: 1, ease: 'power3.out', delay: 1.1 });

    ScrollTrigger.batch('.reveal', { start: 'top 90%', once: true, onEnter: els => g.to(els, { opacity: 1, duration: .8, stagger: .08, ease: 'power2.out' }) });

    const mm = g.matchMedia();
    mm.add('(min-width: 761px)', () => {
      const track = $('#namesTrack');
      const dist = () => Math.max(0, track.scrollWidth - innerWidth);
      // hold the first card still for a beat before the track starts moving
      const HOLD = .3;
      // Pin starts when the bottom of the cards is fully on screen (24px above the
      // viewport bottom), so the whole card stays visible; the section header can
      // scroll off the top. Raise the 24 if the sticky CTA bar covers the cards.
      const namesTl = g.timeline({ scrollTrigger: {
        trigger: track,
        start: 'bottom bottom-=24',
        end: () => '+=' + dist() * (1 + HOLD),
        pin: '.names__pin',
        scrub: .6,
        invalidateOnRefresh: true,
        anticipatePin: 1,
        onRefresh: () => { layoutCps(); updateFlight(); }
      } });
      namesTl.to({}, { duration: HOLD }).to(track, { x: () => -dist(), ease: 'none', duration: 1 });
      g.from('.name-card', { rotateY: -8, opacity: .4, stagger: .1, scrollTrigger: { trigger: '.names', start: 'top 70%', end: 'top 10%', scrub: true } });
      // founder slider auto-demo once
      ScrollTrigger.create({ trigger: '#ba', start: 'top 70%', once: true, onEnter: () => {
        const o = { v: 50 };
        g.timeline().to(o, { v: 82, duration: .9, ease: 'power2.inOut', onUpdate: () => { setBA(o.v); baRange.value = o.v; } })
          .to(o, { v: 22, duration: 1.1, ease: 'power2.inOut', onUpdate: () => { setBA(o.v); baRange.value = o.v; } })
          .to(o, { v: 50, duration: .8, ease: 'power2.inOut', onUpdate: () => { setBA(o.v); baRange.value = o.v; } });
      } });
    });
    g.to('.mission__bg', { yPercent: 10, ease: 'none', scrollTrigger: { trigger: '.mission__hero', start: 'top bottom', end: 'bottom top', scrub: true } });
    g.from('.mission__title', { opacity: 0, y: 30, duration: 1.1, ease: 'power3.out', scrollTrigger: { trigger: '.mission__hero', start: 'top 55%' } });
    g.from('.duo__card', { y: 60, opacity: 0, duration: 1, ease: 'power3.out', stagger: .12, scrollTrigger: { trigger: '.duo', start: 'top 70%' } });

    ScrollTrigger.create({ trigger: '.hero', start: 'top top', end: 'bottom top', onUpdate: s => window.dispatchEvent(new CustomEvent('ff:scroll', { detail: s.progress })) });
    addEventListener('load', () => { ScrollTrigger.refresh(); layoutCps(); updateFlight(); });
  })();
})();
